import { useMemo } from 'react';
import { useFetch } from './useFetch';

export const useProfileMeetingsWithFallback = () => {
    const profileFetch = useFetch('/profile/meeting');
    const bookingFetch = useFetch('/booking');

    const data = useMemo(() => {
        const result = [];

        // IDs dos encontros onde o usuario e anfitriao
        const hostMeetingIds = new Set();

        // Encontros como anfitriao
        if (profileFetch.data && Array.isArray(profileFetch.data)) {
            profileFetch.data.forEach(meeting => {
                hostMeetingIds.add(meeting.id);
                result.push({ ...meeting, _role: 'host' });
            });
        }

        // Encontros como conviva (excluindo os que ja apareceram como anfitriao)
        if (bookingFetch.data && Array.isArray(bookingFetch.data)) {
            bookingFetch.data.forEach(booking => {
                if (hostMeetingIds.has(booking.meeting?.id)) return;

                result.push({
                    meeting_schedule: [{
                        datetime: booking.datetime,
                        purchased: booking.status === 'CONCLUDED',
                        // O calendario usa isso para nao oferecer entrada em
                        // encontro ja finalizado
                        finished_at: booking.meeting_scheduled?.finished_at || null,
                        ID: booking.id,
                        Order: booking,
                    }],
                    ...booking.meeting,
                    Profile: { User: booking.meeting?.Profile?.User || null },
                    _role: 'guest',
                });
            });
        }

        if (result.length === 0 && !profileFetch.data && !bookingFetch.data) return null;
        return result;
    }, [profileFetch.data, bookingFetch.data]);

    const loading = !profileFetch.data && !profileFetch.error && !bookingFetch.data && !bookingFetch.error;
    const error = profileFetch.error && bookingFetch.error ? 'Erro ao buscar dados' : null;

    const mutate = async () => {
        await Promise.all([profileFetch.mutate(), bookingFetch.mutate()]);
    };

    return { data, loading, error, mutate };
};
